import React, { useState } from 'react';
import { TabContent, FormGroup, Input, Label, Button } from 'reactstrap';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import { GRADE_TABS_HEADING } from 'pages/Products/constant';
import ErrorBoundary from 'components/common/ErrorBoundary';
import FSBModal from 'components/common/FSBModal';
import { IoMdAdd } from 'react-icons/io';
import AddEditCategoryGrade from 'components/Drawers/components/CategoryDetailsDrawer/components/CategoriesDetails/components/AddEditCategoryGrade';
import ActiveGrade from './components/ActiveGrade';
import InActiveGrade from './components/InActiveGrade';
import CombinedGrade from './components/CombinedGrade';

const GradesRequest = () => {
  const [activeTabs, setActiveTabs] = useState({
    [GRADE_TABS_HEADING.ACTIVE_GRADE]: false,
    [GRADE_TABS_HEADING.INACTIVE_GRADE]: false,
  });
  const [showAddRecord, setAddRecord] = useState({
    status: false,
    row: '',
    type: ADD_EDIT_CONSTANT.ADD,
  });
  const refetchRef = React.useRef(null);

  const toggleAddRecord = (row, type) => {
    setAddRecord({ status: !showAddRecord.status, row, type });
  };
  const handleClickEdit = (val, type, refetch) => {
    setAddRecord({ status: true, row: val, type });
    if (refetch) {
      refetchRef.current = refetch;
    }
    // toggleAddRecord(val, type);
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setActiveTabs((prevTabs) => ({
      ...prevTabs,
      [name]: checked,
    }));
  };

  const refetch = () => {
    if (refetchRef.current) {
      refetchRef.current();
    }
  };

  // Determine if neither or both checkboxes are selected
  const areBothOrNeitherSelected =
    (activeTabs[GRADE_TABS_HEADING.ACTIVE_GRADE] &&
      activeTabs[GRADE_TABS_HEADING.INACTIVE_GRADE]) ||
    (!activeTabs[GRADE_TABS_HEADING.ACTIVE_GRADE] &&
      !activeTabs[GRADE_TABS_HEADING.INACTIVE_GRADE]);

  const gradeToggle = (
    <form className="mt-1 bg-check-row d-flex me-4 mb-1 products-grade-toggle">
      {Object.entries(GRADE_TABS_HEADING).map(([key, tab]) => (
        <FormGroup
          key={key}
          className="bg-check me-1 d-inline-flex align-items-center mb-0"
          check
        >
          <Label htmlFor={key} className="font-inter fw-medium" check>
            <Input
              type="checkbox"
              name={tab}
              checked={activeTabs[tab]}
              onChange={handleCheckboxChange}
            />
            <span className="ms-1">{tab}</span>
          </Label>
        </FormGroup>
      ))}
    </form>
  );

  const gradeActions = (
    <Button
      color="primary"
      className="rounded-btn p-0 rounded-circle d-flex align-items-center justify-content-center products-add-btn"
      size="sm"
      onClick={toggleAddRecord}
    >
      <IoMdAdd color="#fff" size={20} />
    </Button>
  );

  return (
    <>
      <FSBModal
        title={`${
          showAddRecord.type === ADD_EDIT_CONSTANT.EDIT
            ? showAddRecord.type
            : ADD_EDIT_CONSTANT.ADD
        } Grade`}
        closeButtonLabel=""
        confirmButtonLabel=""
        open={showAddRecord.status}
        toggleAlert={toggleAddRecord}
        onClose={toggleAddRecord}
        message=""
        modalClass="right-drawer"
      >
        <AddEditCategoryGrade
          toggleAddRecord={toggleAddRecord}
          currentRow={showAddRecord.row}
          type={showAddRecord.type}
          refetch={refetch}
        />
      </FSBModal>

      <TabContent>
        {areBothOrNeitherSelected ? (
          <ErrorBoundary>
            <CombinedGrade
              handleClickEdit={handleClickEdit}
              gradeToggle={gradeToggle}
              gradeActions={gradeActions}
            />
          </ErrorBoundary>
        ) : (
          <>
            {activeTabs[GRADE_TABS_HEADING.ACTIVE_GRADE] && (
              <ErrorBoundary>
                <ActiveGrade
                  handleClickEdit={handleClickEdit}
                  gradeToggle={gradeToggle}
                  gradeActions={gradeActions}
                />
              </ErrorBoundary>
            )}
            {activeTabs[GRADE_TABS_HEADING.INACTIVE_GRADE] && (
              <ErrorBoundary>
                <InActiveGrade
                  handleClickEdit={handleClickEdit}
                  gradeToggle={gradeToggle}
                  gradeActions={gradeActions}
                />
              </ErrorBoundary>
            )}
          </>
        )}
      </TabContent>
    </>
  );
};

export default GradesRequest;
